import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col pt-14 sm:pt-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
            <Navbar />
            <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
                <div className="mx-auto mb-8">
                    <img
                        src={`${process.env.PUBLIC_URL}/logo.png`}
                        alt="SceneShop"
                        className="mx-auto w-24 h-24 md:w-28 md:h-28 object-contain"
                    />
                </div>
                <h1 className="text-5xl font-extrabold text-white tracking-tight">404</h1>
                <p className="mt-3 text-lg text-white/80">We couldn't find the page you're looking for.</p>
                <p className="mt-1 text-white/60">The link may be broken or the page may have moved.</p>
                <div className="mt-8 flex items-center justify-center gap-3">
                    <button onClick={() => navigate('/')} className="px-5 py-3 rounded-lg btn-primary">Go to Home</button>
                    <button onClick={() => navigate('/store')} className="px-5 py-3 rounded-lg btn-ghost">Visit Store</button>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default NotFound;
